// extracted by mini-css-extract-plugin
module.exports = {"tvScreen":"Screen_tvScreen__FKFQj","glitchOverlay":"Screen_glitchOverlay__iKYfh","screenOverlay":"Screen_screenOverlay__uOn9b"};